"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisplayName = void 0;
/**
 * Возвращает название react-компонента.
 */
function getDisplayName(component) {
    return component.displayName || component.name || 'Component';
}
exports.getDisplayName = getDisplayName;
